import { SlimProductIsVariantOf } from '$store/sdk/useVariantPossibilities.ts'
import type { AggregateOffer } from 'apps/commerce/types.ts'

export function getCheapestVariantOffers(
    variants: SlimProductIsVariantOf['hasVariant'],
): AggregateOffer | undefined {
    return variants.reduce(
        (prev, cur) => {
            const productQuantity = cur.offers?.offers?.[0]?.inventoryLevel?.value ?? 0

            if (!prev && productQuantity > 0) {
                return cur.offers
            }

            // deno-lint-ignore no-extra-non-null-assertion
            if (prev?.lowPrice! > cur?.offers!.lowPrice && productQuantity > 0) {
                return cur.offers ?? prev
            }

            return prev
        },
        undefined as AggregateOffer | undefined,
    )
}
